import { BoxContentExplorer } from "@onesolution/components";
import { useClientInfos } from "@onesolution/hooks";
import { useSearch } from "@tanstack/react-router";

export default function FilesPage() {
	const clientInfos = useClientInfos();
	const search = useSearch({ from: "/app/_layout/files" }) as {
		folderId?: string;
	};

	return (
		<BoxContentExplorer
			className="h-full"
			rootFolderId={search.folderId || clientInfos?.boxRootFolderId || "0"}
		/>
	);
}
